"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOperation = void 0;
const csvtojson_1 = __importDefault(require("csvtojson"));
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const consolidateErrors_1 = require("./consolidateErrors");
const errorUtils_1 = require("./errorUtils");
const helpers_1 = require("./helpers");
const typeguards_1 = require("./typeguards");
const utils_1 = require("./utils");
const consolidateSanitizationErrors = (sanitizationErrors) => {
    return (0, consolidateErrors_1.consolidateErrors)(sanitizationErrors, (error) => error.name, // Group by field name
    (error) => ({
        value: error.value,
        expectedType: error.expectedType,
        expectedFormat: error.expectedFormat,
        row: String(error.rowIndex + 1),
    }), // Map to row data
    (fieldName) => `Field [${fieldName}] has invalid values`);
};
const consolidateFormulaErrors = (formulaErrors) => {
    return (0, consolidateErrors_1.consolidateErrors)(formulaErrors, (error) => error.formula, // Group by formula
    (error) => ({
        message: error.message,
        row: String(error.rowIndex + 1),
    }), // Map to row data
    (formula) => `Formula [${formula}] has errors`);
};
const consolidateUnknownErrors = (unknownErrors) => {
    return (0, consolidateErrors_1.consolidateErrors)(unknownErrors, (error) => error.message, // Group by message
    (error) => ({
        row: String(error.rowIndex + 1),
    }), // Map to row data
    (message) => `${message}`);
};
const consolidateToStructuredErrors = (errors) => {
    const sanitizationErrors = errors.filter((error) => error.type === 'editSanitizationError');
    const unknownErrors = errors.filter((error) => error.type === 'editUnknownError');
    const formulaErrors = errors.filter((error) => error.type === 'editFormulaEvaluationError');
    // we want to consolidate the errors if there are too many of those.
    return [
        ...consolidateSanitizationErrors(sanitizationErrors),
        ...consolidateFormulaErrors(formulaErrors),
        ...consolidateUnknownErrors(unknownErrors),
    ];
};
const getFieldName = (modification) => {
    switch (modification.type) {
        case 'delete_field':
            return modification.field;
        case 'add_field':
            return modification.fieldConfig.field;
        case 'rename_field':
            return modification.newName;
        default:
            return (0, common_1.finleyAssertUnreachable)(modification);
    }
};
const getFormulaStrings = (transformation) => {
    return transformation.fieldModifications
        .filter((mod) => mod.type === 'add_field')
        .map((mod) => mod.formula);
};
const checkErrors = (transformation) => {
    const errors = [];
    _.chain(transformation.fieldModifications)
        .countBy(getFieldName)
        .forEach((count, fieldName) => {
        if (count > 1) {
            errors.push({
                type: 'metadataValidation',
                message: `field ${fieldName} declared multiple times`,
            });
        }
    })
        .value();
    const fieldsThatMustExist = transformation.fieldModifications
        .map((mod) => {
        switch (mod.type) {
            case 'delete_field':
                return mod.field;
            case 'rename_field':
                return mod.oldName;
            default:
                return null;
        }
    })
        .filter(common_1.typeguards.isNotNullOrUndefined);
    fieldsThatMustExist.forEach((deletedField) => {
        if (!transformation.srcDataTape.baseFields.find(({ field }) => field === deletedField)) {
            errors.push({
                type: 'metadataValidation',
                message: `edit operation: field:[${deletedField}] does not exist in the input`,
            });
        }
    });
    const fieldsThatMustNotExist = transformation.fieldModifications
        .map((mod) => (mod.type === 'rename_field' ? mod.newName : null))
        .filter(common_1.typeguards.isNotNullOrUndefined);
    fieldsThatMustNotExist.forEach((mustExistField) => {
        if (transformation.srcDataTape.baseFields.find(({ field }) => field === mustExistField)) {
            errors.push({
                type: 'metadataValidation',
                message: `edit operation: field:[${mustExistField}] already exist in the input`,
            });
        }
    });
    const availableVariables = new Set(transformation.srcDataTape.baseFields.map(({ field }) => field));
    getFormulaStrings(transformation).forEach((formulaString) => {
        const formulaErrors = (0, formula_engine_1.getFormulaErrors)(formulaString, availableVariables);
        formulaErrors.errorMessages.forEach((message) => {
            errors.push({ type: 'metadataValidation', message });
        });
    });
    return errors;
};
const captureMetaDatErrors = (error) => {
    if (Array.isArray(error)) {
        return error;
    }
    return [
        {
            type: 'metadataValidation',
            message: (0, common_1.getErrorMessage)(error),
        },
    ];
};
const validateTransform = (transformation) => {
    const errors = checkErrors(transformation);
    if (errors.length) {
        return { isValid: false, errors };
    }
    try {
        // we start with src tape, and apply transformation to generate new
        // tape definition and collect any errors on the way.
        const outputFields = _.cloneDeep(transformation.srcDataTape.baseFields);
        const getExistingFieldIndex = (fieldToCheck) => outputFields.findIndex((existing) => existing.field === fieldToCheck);
        // apply each modification
        transformation.fieldModifications.forEach((mod) => {
            switch (mod.type) {
                case 'add_field': {
                    const newFieldConfig = (0, helpers_1.getSanitizedConfig)({
                        configBeforeSanitize: mod.fieldConfig,
                        // we do not want to field names to be standardized.
                        // they are already sanitized (or not) by sanitize operation as appropriate.
                        sanitizeFieldNames: false,
                    });
                    // add_field may replace existing definitions.
                    const index = getExistingFieldIndex(newFieldConfig.field);
                    if (index === -1) {
                        outputFields.push(newFieldConfig);
                    }
                    else {
                        outputFields[index] = newFieldConfig;
                    }
                    break;
                }
                case 'delete_field': {
                    const fieldToBeDeleted = mod.field;
                    const index = getExistingFieldIndex(fieldToBeDeleted);
                    (0, common_1.finleyAssert)(index !== -1, 'field to be deleted must exist');
                    outputFields.splice(index, 1);
                    break;
                }
                case 'rename_field': {
                    const fieldToBeDeleted = mod.oldName;
                    const fieldToBeAdded = mod.newName;
                    const oldFieldIndex = getExistingFieldIndex(fieldToBeDeleted);
                    (0, common_1.finleyAssert)(oldFieldIndex !== -1, 'field to be renamed must exist');
                    outputFields[oldFieldIndex].field = fieldToBeAdded;
                    break;
                }
                default:
                    (0, common_1.finleyAssertUnreachable)(mod);
            }
        });
        return {
            isValid: true,
            data: {
                delimiter: ',',
                baseFields: outputFields,
                sanitizedFieldNames: false,
            },
        };
    }
    catch (error) {
        const metadataErrors = captureMetaDatErrors(error);
        return { isValid: false, errors: metadataErrors };
    }
};
const processInput = ({ inputData, transformation, formulaEngine }) => {
    const errors = [];
    const outputData = [];
    inputData.forEach((row, idx) => {
        formulaEngine?.setVariables(row);
        const newRow = _.cloneDeep(row);
        transformation.fieldModifications.forEach((modification) => {
            switch (modification.type) {
                case 'delete_field':
                    delete newRow[modification.field];
                    break;
                case 'add_field': {
                    try {
                        (0, common_1.finleyAssert)(formulaEngine, 'formula engine was not passed');
                        let formulaResult = 'formula_not_executed';
                        try {
                            formulaResult = formulaEngine.evaluate(modification.formula);
                        }
                        catch (err) {
                            const formulaEvaluationError = {
                                type: 'editFormulaEvaluationError',
                                formula: modification.formula,
                                message: (0, common_1.getErrorMessage)(err),
                                rowIndex: idx,
                            };
                            errors.push(formulaEvaluationError);
                        }
                        const typeCheckedResult = _.toString((0, helpers_1.getSanitizedDataTapeField)(modification.fieldConfig, _.toString(formulaResult))); // throws InvalidField if the result doesn't match the declared type
                        newRow[modification.fieldConfig.field] = typeCheckedResult;
                    }
                    catch (err) {
                        if ((0, typeguards_1.isInvalidField)(err)) {
                            const { name, value, expectedType, expectedFormat } = err;
                            const sanitizationError = {
                                name,
                                value,
                                expectedType,
                                expectedFormat,
                                type: 'editSanitizationError',
                                rowIndex: idx,
                            };
                            errors.push(sanitizationError);
                        }
                        else {
                            const editUnknownError = {
                                type: 'editUnknownError',
                                message: (0, common_1.getErrorMessage)(err),
                                rowIndex: idx,
                            };
                            errors.push(editUnknownError);
                        }
                    }
                    break;
                }
                case 'rename_field':
                    newRow[modification.newName] = newRow[modification.oldName];
                    delete newRow[modification.oldName];
                    break;
                default:
                    (0, common_1.finleyAssertUnreachable)(modification);
            }
        });
        outputData.push(newRow);
    });
    return { errors, outputData };
};
const performTransform = async ({ dataTapeBuffers, transformation, }) => {
    try {
        (0, common_1.finleyAssert)(dataTapeBuffers.length === 1, 'Only one data tape buffer is expected');
        const srcDataTapeBuffer = dataTapeBuffers[0];
        const srcDataTape = transformation.srcDataTape;
        const csvString = common_1.finleyBuffer.toString(srcDataTapeBuffer);
        const delimiter = srcDataTape.delimiter;
        const headers = await (0, helpers_1.getHeaders)({
            csvString,
            delimiter,
            sanitizeFieldNames: false, // field names are sanitized previously by sanitize op
        });
        const inputData = await (0, csvtojson_1.default)({
            headers,
            delimiter,
        }).fromString(csvString);
        const formulaStrings = getFormulaStrings(transformation);
        const formulaEngine = formulaStrings.length
            ? (0, formula_engine_1.createFormulaEngine)(finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, formulaStrings, undefined)
            : undefined;
        const { errors, outputData } = processInput({
            inputData,
            transformation,
            formulaEngine,
        });
        if (errors.length) {
            return {
                isValid: false,
                errors: consolidateToStructuredErrors(errors),
            };
        }
        const tapeDefinitionResult = validateTransform(transformation);
        (0, common_1.finleyAssert)(tapeDefinitionResult.isValid, 'Tape definition is invalid');
        const outputDataTape = tapeDefinitionResult.data;
        (0, common_1.finleyAssert)(outputDataTape, 'OutputDataTape must be defined');
        const outputBuffer = (0, utils_1.rowDataToCsv)(outputData, outputDataTape);
        return { isValid: true, data: { outputBuffer }, supplementals: [] };
    }
    catch (error) {
        return (0, errorUtils_1.convertErrorToTapeFailureResult)(error, 'edit: ');
    }
};
exports.transformOperation = {
    operation: 'edit',
    validateTransform,
    performTransform,
};
//# sourceMappingURL=edit-transform.js.map